import React from "react";
import { Lock, Unlock } from "lucide-react";
import { ShapeControlProps } from "./types";
import { ShapeControlButton } from "./ShapeControlButton";
import { useEditorShortcuts } from "../../../shortcuts/EditorShortcutContext/useEditorShortcuts";

export const ShapeControlLock: React.FC<ShapeControlProps> = ({
  shape,
  onUpdate,
}) => {
  const { shortcuts } = useEditorShortcuts();
  return (
    <ShapeControlButton
      onClick={() => onUpdate({ locked: !shape.locked })}
      title={shape.locked ? "Unlock" : "Lock"}
      icon={shape.locked ? Unlock : Lock}
      shortcut={shortcuts.shapeSelection.lockUnlock}
    />
  );
};
